<div class="modal-backdrop">
<div class="email-form-container">
  <div class="card">
    <div class="card-header">
      <h3>Compose Email</h3>
      <div class="header-actions">
        <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="sendEmail()" [disabled]="emailForm.invalid || isSending">
          {{ isSending ? 'Sending...' : 'Send' }}
        </button>
      </div>
    </div>
    <div class="card-body">
      <form [formGroup]="emailForm" (ngSubmit)="sendEmail()">
        
        <!-- Sender -->
        <div class="form-group">
          <label for="from">From</label>
          <input type="text" id="from" class="form-control" formControlName="from">
        </div>

        <!-- Recipients -->
        <div class="form-group">
          <label for="to">To <span class="helper-text">(comma(,) separated)</span></label>
          <input type="text" id="to" class="form-control" formControlName="to" placeholder="Enter email addresses separated by commas">
        </div>

        <!-- CC -->
        <!-- <div class="form-group">
          <label for="cc">Cc</label>
          <input type="text" id="cc" class="form-control" formControlName="cc">
        </div> -->

        <!-- Subject -->
        <div class="form-group">
          <label for="subject">Subject</label>
          <input type="text" id="subject" class="form-control" formControlName="subject">
        </div>
        <!-- Attachments -->
        <div class="form-group attachment-section">
          <label>Attachments</label>
          <div class="attachment-actions">
            <button type="button" class="btn btn-secondary btn-sm attach-btn" (click)="openFirebaseStoragePicker()">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"/>
              </svg> Attach File
            </button>
          </div>
          <ul class="list-group" *ngIf="attachments && attachments.length > 0">
            <li class="list-group-item" *ngFor="let file of attachments; let i = index">
              <span class="file-name">{{ file.name }}</span>
              <button type="button" class="btn btn-danger btn-sm" *ngIf="!fixedAttachments" (click)="removeAttachment(i)">Remove</button>
              <span class="fixed-attachment-note" *ngIf="fixedAttachments">Attached statement</span>
            </li>
          </ul>
        </div>
        <!-- Body -->
        <div class="form-group body-group">
          <div class="message-header">
            <label for="body">Message</label>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="saveTemplate()" title="Save current content as default template">Save Template</button>
          </div>
          <quill-editor *ngIf="showEditor" id="body" formControlName="body" [modules]="quillConfig" placeholder="Compose your email..."></quill-editor>
        </div>



      </form>
    </div>
  </div>
</div>
</div>
